// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-dropdown {
  position: relative;
  display: inline-flex;
}

.select-dropdown-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 53px;
  width: 100%;
  height: 40px;
  padding: 8px;
  border: none;
  border-radius: 4px;
  background-color: var(--surface-tertiary);
  color: var(--text-primary);
  border: 1px solid var(--input-border);
  cursor: pointer;
  white-space: nowrap;
  outline: none;
  transition: background 0.12s;
  box-sizing: border-box;
}

.select-dropdown-trigger:hover {
  border: 1px solid var(--border-primary-brand);
}

.select-dropdown-label {
  flex: 1;
  text-align: center;
}

.select-dropdown-arrow {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.select-dropdown-menu {
  background-color: var(--surface-primary);
  border: 1px solid var(--border-tertiary);
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  padding: 4px 0;
  max-height: 200px;
  overflow-y: auto;
}

.select-dropdown-menu::-webkit-scrollbar {
  width: 4px;
}

.select-dropdown-menu::-webkit-scrollbar-thumb {
  background-color: var(--surface-disabled);
  border-radius: 2px;
}

.select-dropdown-menu::-webkit-scrollbar-track {
  background-color: transparent;
}

.select-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  color: var(--text-primary);
  cursor: pointer;
  white-space: nowrap;
}

.select-dropdown-item:hover {
  background: var(--color-brand-hover2, #f9e2d6);
}

.select-dropdown-item-active {
  color: var(--color-brand);
}

.select-dropdown-tick {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.select-dropdown-tick path {
  fill: var(--color-brand);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/AdvanceChartWidget/components/common/SelectDropdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B","sourcesContent":[".select-dropdown {\n  position: relative;\n  display: inline-flex;\n}\n\n.select-dropdown-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 53px;\n  width: 100%;\n  height: 40px;\n  padding: 8px;\n  border: none;\n  border-radius: 4px;\n  background-color: var(--surface-tertiary);\n  color: var(--text-primary);\n  border: 1px solid var(--input-border);\n  cursor: pointer;\n  white-space: nowrap;\n  outline: none;\n  transition: background 0.12s;\n  box-sizing: border-box;\n}\n\n.select-dropdown-trigger:hover {\n  border: 1px solid var(--border-primary-brand);\n}\n\n.select-dropdown-label {\n  flex: 1;\n  text-align: center;\n}\n\n.select-dropdown-arrow {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.select-dropdown-menu {\n  background-color: var(--surface-primary);\n  border: 1px solid var(--border-tertiary);\n  border-radius: 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n  padding: 4px 0;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.select-dropdown-menu::-webkit-scrollbar {\n  width: 4px;\n}\n\n.select-dropdown-menu::-webkit-scrollbar-thumb {\n  background-color: var(--surface-disabled);\n  border-radius: 2px;\n}\n\n.select-dropdown-menu::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.select-dropdown-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  color: var(--text-primary);\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.select-dropdown-item:hover {\n  background: var(--color-brand-hover2, #f9e2d6);\n}\n\n.select-dropdown-item-active {\n  color: var(--color-brand);\n}\n\n.select-dropdown-tick {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.select-dropdown-tick path {\n  fill: var(--color-brand);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
